
export const shareRoute = (data, service) => async (dispatch) => {
    try {
        dispatch({
            type: 'SHARE_ROUTE_ACTION',
            payload: data,
            service: service
        });


    } catch (error) {
    } finally {

    }
}
export const profileRoute = (data, nestedRoute, service) => async (dispatch) => {
    try {
        dispatch({
            type: 'PROFILE_ROUTE_ACTION',
            payload: data,
            service: service,
            nestedRoute: nestedRoute
        });


    } catch (error) {
    } finally {

    }
}
export const nestedServiceRoute = (data) => async (dispatch) => {
    try {
        dispatch({
            type: 'NESTED_SERVICE_ROUTE',
            payload: data,
        });


    } catch (error) {
    } finally {

    }
}
